import countryLib from './country_lib.json';

function exactPhoneRE(dialCode,prefix,exactLen) {
  if (prefix >= 0) {
    // Example: Brazil - /^(\+?55)?[0]?[1-9]\d{9}$/
    return new RegExp(`^(\\+?${dialCode})?[${prefix}]?` +
                      '[1-9]\\d{' + regexLen(exactLen) + '}$');
  } else {
    // Example: Bahrain - /^(\+?973)?[1-9]\d{7}$/
    return new RegExp(`^(\\+?${dialCode})?` +
                      '[1-9]\\d{' + regexLen(exactLen) + '}$');
  }
}
function spanPhoneRE(dialCode,prefix,minLen,maxLen) {
  if (prefix >= 0) {
    // Example: Australia - /^(\+?61)?[0]?[1-9]\d{3,14}$/
    return new RegExp(`^(\\+?${dialCode})?[${prefix}]?` +
                      '[1-9]\\d{' + regexLen(minLen) + ',' +
                      regexLen(maxLen) + '}$');
  } else {
    // Example: Singapore - /^(\+?65)?[1-9]\d{7,11}$/
    return new RegExp(`^(\\+?${dialCode})?` +
                      '[1-9]\\d{' + regexLen(minLen) + ',' +
                      regexLen(maxLen) + '}$');
  }
}
// These regex patterns include length validation:
// Reducing the max/min/exact by one within the pattern gives us an accuate overall length
function regexLen(num) {
  return num - 1;
}



export function legacyPhoneFormat(countryCode) {
  const usphoneRE = new RegExp('^(\\+?1-?)?(\\([2-9]([02-9]\\d|1[02-9])\\)|' +
                               '[2-9]([02-9]\\d|1[02-9]))-?[2-9]\\d{2}-?\\d{4}$');
  const gbphoneRE = new RegExp('(?:(?:(?:00\\s?|\\+)44\\s?)|(?:\\(?0))(?:\\d{2}\\)?\\s?' +
                               '\\d{4}\\s?\\d{4}|\\d{3}\\)?\\s?\\d{3}\\s?\\d{3,4}|\\d{4}\\)?\\s?' +
                               '(?:\\d{5}|\\d{3}\\s?\\d{3})|\\d{5}\\)?\\s?\\d{4,5})');
  const intphoneRE = /(?:(\+))?([0-9\-\s()])*[0-9]+/;

  switch(countryCode) {
    case 'US':
    case 'CA':
      return usphoneRE;
    case 'GB':
      return gbphoneRE;
    case 'international':
      return intphoneRE;
    default:
      return false;
  }
}

/**
 * Returns the appropriate phone regex based on country code
 */
/* eslint-disable complexity */
export function phoneNumberFormat(countryCode) {
  // If country code isn't present in lib, fallback to countryLib.international
  if (legacyPhoneFormat(countryCode)) {
    return legacyPhoneFormat(countryCode);
  }

  const country = countryLib[countryCode];
  const phoneData = country?.phone;
  let pattern = legacyPhoneFormat('international');

  if (phoneData?.pattern) {
    // Retun unique pattern
    pattern = phoneData.pattern;
  } else if (phoneData?.exactLen) {
    // Optional prefix, exact length required
    pattern = exactPhoneRE(phoneData.dialCode,phoneData.prefix,phoneData.exactLen);
  } else if (phoneData?.minLen && phoneData?.maxLen) {
    // Optional prefix, min and max length required
    pattern = spanPhoneRE(phoneData.dialCode,phoneData.prefix,phoneData.minLen,phoneData.maxLen);
  }
  return pattern;
}
/* eslint-enable complexity */

/**
 * Returns the appropriate phone regex based on country code
 */
export function phoneDialCode(countryCode) {
  const phoneData = countryLib[countryCode]?.phone;
  return phoneData?.dialCode;
}

export function phonePrefix(countryCode) {
  const phoneData = countryLib[countryCode]?.phone;
  return phoneData?.prefix;
}
